<template>
<div id="PU30">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
        <img id="photo" src="./img/PU30/pu_30.png"/>
      </div>
      <div id="desc" class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
        <!-- <div><h2 style="color: #00aeff">{{msg}}</h2></div> -->
        <table >
          <table style="margin:0 auto;">
            <thead>
              <tr>
                <th v-for="item in NameTableSecond">{{item}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in item_table">
                <td :colspan="item.value ? 1 : 2">{{item.name}}</td>
                <td v-if="item.value">{{item.value}}</td>
              </tr>
            </tbody>
          </table>
        </table>
      </div>а
    </div>
  </div>
    <div id="nineteen">

    </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Модульное оптико-электронное средство МОЭC-19',
      text: 'Объектив представляет собой малоапертурный катадиоптрический широкопольный оптический прибор высокой светосилы со сферической оптикой, который выполнен по системе Шенкера с трехлинзовым полноапертурным корректором, с задним расположением фотоприёмного устройства в фокусе Кассегрена. Компоновка  и применённая оптическая схема  позволяют  использовать фотоприёмную аппаратуру произвольных габаритов и, в силу размещения вторичного зеркала на линзе полноапертурного корректора, избежать применения системы механических конструктивных элементов крепления вторичного зеркала - растяжек, что исключает помехи от них на изображении, и позволяет эффективно обнаруживать слабые точечные объекты вблизи ярких источников света (звезд) в поле зрения.',
      NameTableSecond: ['Параметры и характеристики (свойства)', 'Показатели (значения)'],
      item_table: [
        {
          name: 'Вид павильона-укрытия',
          value: 'Башенного типа с открывающейся двухсегментной крышей'
        },
        {
          name: 'Конструктивное исполнение',
          value: 'Сборно-разборный, цельнометаллический, с фанерным настилом пола нижнего и верхнего отсеков, с механически зависимым сопряжением подвижных сегментов крыши'
        },
        {
          name: 'Привод крыши',
          value: 'Электрический, реверсивный, с двусторонней цепной передачей на внешний сегмент крыши'
        },
        {
          name: 'Электропитание павильона',
          value: 'Переменный ток напряжением 220 (230) В, частотой 50 Гц'
        },
        {
          name: 'Мотор-редуктор привода крыши',
          value: ''
        },
        {
          name: '- тип мотор-редуктора',
          value: 'Двухступенчатый, червячный, с трёхфазным асинхронным электродвигателем'
        },
        {
          name: '- электропитание и мощность электродвигателя',
          value: '220/380 В, 50 Гц, 0,55 кВт'
        },
        {
          name: '- передаточное отношение редуктора',
          value: '600'
        },
        {
          name: '- частота вращения выходного вала редуктора (без нагрузки)*',
          value: '2,3 1/мин'
        },
        {
          name: 'Цепная передача привода крыши',
          value: ''
        },
        {
          name: '- передаточное отношение цепной передачи',
          value: '1,6875'
        },
        {
          name: '- частота вращения вала привода крыши (без нагрузки)*',
          value: '1,363 1/мин'
        },
        {
          name: 'Время открытия (закрытия) крыши при максимальной скорости привода, с, не более',
          value: '40'
        },
        {
          name: 'Освещение павильона',
          value: 'Светодиодные светильники в нижнем и верхнем отсеках'
        },
        {
          name: 'Основные размеры павильона*, мм',
          value: ''
        },
        {
          name: '- размер опорной площадки павильона в плане (со всеми опорными основаниями сборочно-монтажного комплекта)',
          value: '2730×1840'
        },
        {
          name: '- высота от уровня грунта (крыша закрыта)',
          value: '4354'
        },
        {
          name: '- наибольший размер в направлении «север – юг» (крыша закрыта)',
          value: '2912'
        },
        {
          name: '- наибольший размер в направлении «восток – запад»',
          value: '2520'
        },
        {
          name: '- высота основания (опорной колонны) под ОЭК относительно грунта**',
          value: 'Определяется конструкцией устанавливаемого в павильоне ОЭК'
        },
        {
          name: '- высота оснований (опорных элементов) под павильон относительно грунта',
          value: '200'
        },
        {
          name: '- высота пола верхнего отсека относительно опорного основания павильона',
          value: '2130'
        },
        {
          name: '- высота корзины верхнего отсека относительно пола верхнего отсека',
          value: '730'
        },
        {
          name: '- высота верха корзины верхнего отсека относительно опорного основания павильона',
          value: '2860'
        },
        {
          name: 'Масса павильона (без сборочно-монтажного комплекта)*, кг',
          value: '1600'
        },
        {
          name: 'Количество размещаемых ОЭК (телескопов)',
          value: 'Один'
        },
        {
          name: 'Типовая апертура объективов оптических модулей размещаемых ОЭК',
          value: '19 см (19×2, 19×4) см, 25 см, 30 см, 40 см, 50 см'
        },
        {
          name: 'Управление приводом крыши',
          value: ''
        },
        {
          name: '- ручное',
          value: 'С помощью пульта управления (кнопочного поста с двойной кнопкой) павильона'
        },
        {
          name: '- дистанционное и удалённое',
          value: 'По сети LAN и через интернет-соединение'
        },
        {
          name: 'Возможность вращения оптического модуля ОЭК при закрытой крыше павильона',
          value: 'Может быть ограничено типом опорно-поворотного устройства и габаритом оптического модуля ОЭК'
        }
      ]

    }
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
#PU30 {
    height: 100%;
    color: white;
}
img#photo{
  margin-top: 13%;
  width: 90%;
}
div #caption{
	color: #78daff;
	opacity: 0.9;
	text-decoration: underline;
}
div#desc{
  width: 100%;
}
div#desc p.text{
  text-align: justify;
}
table{
  table-layout: fixed;
  font-size: 1em;
}
table td {
    height: 5vh;
}

</style>
